// import Select from "react-select";
import Creatable from "react-select/creatable";
import special1 from "assets/images/Component 1.png";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";
import { useEffect, useState } from "react";

import {
  AiOutlineClear,
  AiOutlinePlusCircle,
  AiOutlineMinusCircle
} from "react-icons/ai";
import { HiOutlineSave } from "react-icons/hi";
import ReactTooltip from "react-tooltip";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import {
  translateToReactSelect,
  productDataToQuery
} from "utils/helperFunctions";
import toast from "react-hot-toast";
import React from "react";
import chroma from "chroma-js";

import Select, { StylesConfig } from "react-select";
import Slider, { Range } from "rc-slider";
import colors from "react-multi-date-picker/plugins/colors";

import sendRequest from "hooks/useAxios";
import { isObjectContainsInArray } from "utils/helperFunctions";
import { FilePond, registerPlugin, create } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import "filepond/dist/filepond.min.css";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const EditSpecialProductModal = ({
  products,
  configHandler,
  tagOption,
  setTagoption,
  productOption
}) => {
  const [displayStatus, setDisplayStatus] = useState({
    Single0: false,
    Plural0: false,
    Single1: false,
    Plural1: false,
    Single2: false,
    Plural2: false,
    Single3: false,
    Plural3: false
  });

  const [productData, setProductData] = useState([
    // {
    //   source: "",
    //   url: {
    //     ids: "",
    //     files: "",
    //     tags: [],
    //     brands: [],
    //     priceRange: [0, 0],
    //     title: "",
    //     rankRange: [],
    //     color: [],
    //     sortTypes: {
    //       inventory: false,
    //       discounted: false,
    //       cheapest: false,
    //       mostExpensive: false,
    //       newest: false,
    //     },
    //     toggleDisplay: true,
    //   },
    // },
    // {
    //   source: "",
    //   url: {
    //     ids: "",
    //     files: "",
    //     tags: [],
    //     brands: [],
    //     priceRange: [0, 0],
    //     title: "",
    //     rankRange: [],
    //     color: [],
    //     sortTypes: {
    //       inventory: false,
    //       discounted: false,
    //       cheapest: false,
    //       mostExpensive: false,
    //       newest: false,
    //     },
    //     toggleDisplay: true,
    //   },
    // },
    // {
    //   source: "",
    //   url: {
    //     ids: "",
    //     files: "",
    //     tags: [],
    //     brands: [],
    //     priceRange: [0, 0],
    //     title: "",
    //     rankRange: [],
    //     color: [],
    //     sortTypes: {
    //       inventory: false,
    //       discounted: false,
    //       cheapest: false,
    //       mostExpensive: false,
    //       newest: false,
    //     },
    //     toggleDisplay: true,
    //   },
    // },
    // {
    //   source: "",
    //   url: {
    //     ids: "",
    //     files: "",
    //     tags: [],
    //     brands: [],
    //     priceRange: [0, 0],
    //     title: "",
    //     rankRange: [],
    //     color: [],
    //     sortTypes: {
    //       inventory: false,
    //       discounted: false,
    //       cheapest: false,
    //       mostExpensive: false,
    //       newest: false,
    //     },
    //     toggleDisplay: true,
    //   },
    // },
  ]);
  console.log("productData", productData);
  const translateBrandToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.name = arrayValue[index].label;
        obj.id = arrayValue[index].value;
        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].name;
        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }

    return after;
  };
  const [brandOption, setBrandOption] = useState([]);

  // const [tagOption, setTagOption] = useState([]);

  useEffect(() => {
    setProductData(products);
    // for (let i = 0; i < 4; i++) {
    //   console.log(i);
    //   setProductData((prev) => {
    //     let x = [...prev];
    //     x[i].source = products[i].source;
    //     return x;
    //   });
    //   if (!products[i].url) {
    //     console.log("source");
    //   } else if (products[i].url && products[i].url.tags) {
    //     console.log("url");
    //     setProductData(products);
    //   } else if (products[i].url && !products[i].url.tags) {
    //     // console.log("xx");
    //     setSingleProduct(products[i].url);
    //   }
    //   //   // if (products[i].url.tags.length > 0) {
    //   //   // console.log("plural");
    //   //   // setProductData(products);
    //   //   // }
    //   //   // else if (products[i].label) {
    //   //   //     console.log("single");
    //   //   //     // let x = [...products[i]]
    //   //   //     // setProductData({ ...products[i], url: JSON.parse(products[i].url) });
    //   //   //   }
    // }
  }, [products]);
  // const [url1, setUrl1] = useState(productDataToQuery(products[1].url, true));

  // console.log(url1);
  // setProductData((prev) => {
  //   let x = [...prev];
  //   // x[0] = productDataToQuery(products[0].url, true);
  //   // x[1] = productDataToQuery(products[1].url, true);
  //   // x[2] = productDataToQuery(products[2].url, true);
  //   // x[3] = productDataToQuery(products[3].url, true);
  //   return x;

  //   // console.log("www", productDataToQuery(products[i].url, true));
  // });
  const [singleProduct, setSingleProduct] = useState([
    { ids: "", files: "" },
    { ids: "", files: "" },
    { ids: "", files: "" },
    { ids: "", files: "" }
  ]);
  const [query, setQuery] = useState({
    Query0: "",
    Query1: "",
    Query2: "",
    Query3: ""
  });
  const changeStatus = (names, value) => {
    setDisplayStatus(prev => {
      return { ...prev, [names]: value };
    });
  };
  const changeHandler = (i, names, value) => {
    setProductData(prev => {
      let x = [...prev];
      switch (names) {
        case "tags":
          x[i].url.tags = value;
          break;
        case "brands":
          x[i].url.brands = value;
          break;
        case "priceRange":
          x[i].url.priceRange = [...value];
          break;
        case "url":
          x[i].url = value;
          break;
        // case "title":
        //   x[i].url.title = value;
        //   break;
        case "source":
          x[i].source = value.target.files[0];
          break;
      }

      return x;
    });
  };
  const changeHandlerSingleProduct = (i, names, value) => {
    setSingleProduct(prev => {
      let y = [...prev];
      switch (names) {
        case "ids":
          y[i].ids = value.value;
          break;
        case "files":
          y[i].files = value;
          break;
      }
      return y;
    });
  };
  const setQueryHandler = (names, value, files) => {
    setQuery(prev => {
      return { ...prev, [names]: `${value}${files}&` };
    });
  };
  const [validate, setValidate] = useState({
    cover0: true,
    cover1: true,
    cover2: true,
    cover3: true
  });
  const validateHandler = (i, names, value) => {
    setValidate(prev => {
      return { ...prev, [names]: value };
    });
  };

  const validation = () => {
    let isValide = true;
    for (let i = 0; i < productData.length; i++) {
      if (productData[i].source != "__") {
        validateHandler(i, `cover${i}`, true);
      } else {
        validateHandler(i, `cover${i}`, false);
        isValide = false;
      }
    }
    return isValide;
  };

  const saveData = () => {
    let formDataBox = new FormData();
    // if (displayStatus.Single0 == true) {
    //   formDataBox.append("url_1", JSON.stringify(singleProduct[0].ids));
    //   // formDataBox.append("url_1", JSON.stringify(productData[0].url));
    // } else if (displayStatus.Plural0 == true) {
    //   formDataBox.append(
    //     "url_1",
    //     productDataToQuery(productData[0].url, false)
    //   );
    // }
    // if (displayStatus.Single1 == true) {
    //   formDataBox.append("url_2", JSON.stringify(singleProduct[1].ids));
    //   // formDataBox.append("url_2", productData[1].url);
    // } else if (displayStatus.Plural1 == true) {
    //   formDataBox.append(
    //     "url_2",
    //     productDataToQuery(productData[1].url, false)
    //   );
    // }
    // if (displayStatus.Single2 == true) {
    //   formDataBox.append("url_3", JSON.stringify(singleProduct[2].ids));
    //   // formDataBox.append("url_3", productData[2].url);
    // } else if (displayStatus.Plural2 == true) {
    //   formDataBox.append(
    //     "url_3",
    //     productDataToQuery(productData[2].url, false)
    //   );
    // }

    // if (displayStatus.Single3 == true) {
    //   formDataBox.append("url_2", JSON.stringify(singleProduct[3].ids));
    //   // formDataBox.append("url_2", productData[3].url);
    // } else if (displayStatus.Plural3 == true) {
    //   formDataBox.append(
    //     "url_4",
    //     productDataToQuery(productData[3].url, false)
    //   );
    // }
    formDataBox.append(
      "url_1",
      productDataToQuery({ ...productData[0].url, rankRange: [0, ""] }, false)
    );
    formDataBox.append(
      "url_2",
      productDataToQuery({ ...productData[1].url, rankRange: [0, ""] }, false)
    );
    formDataBox.append(
      "url_3",
      productDataToQuery({ ...productData[2].url, rankRange: [0, ""] }, false)
    );
    formDataBox.append(
      "url_4",
      productDataToQuery({ ...productData[3].url, rankRange: [0, ""] }, false)
    );
    formDataBox.append("file_1", productData[0].source);
    formDataBox.append("file_2", productData[1].source);
    formDataBox.append("file_3", productData[2].source);
    formDataBox.append("file_4", productData[3].source);
    // for (var [key, value] of formDataBox.entries()) {
    //   console.log(key, value);
    // }
    sendRequest("edit_shop_cover_box", formDataBox).then(data => {
      if (data.status == 200) {
        toast.success("ویرایش با موفقیت انجام شد.");
        configHandler();
        document.querySelector("#editSpecialProductModal .btn-close").click();
      } else {
        toast.error("مشگلی در ویرایش پیش آمده است.");
      }
    });
  };

  const translateProductToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.title = arrayValue[index].label;
        obj.id = arrayValue[index].value;

        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].title;

        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }

    return after;
  };

  // const [productOption, setProductOption] = useState([]);
  useEffect(() => {
    // sendRequest("Find_products", {
    //   tbl_name: `left join,files,coverimg_fileid,id`,
    //   conditions: "files.type/=/1",
    // }).then(({ data }) => {
    //   setProductOption(translateProductToReactSelect(data, false));
    // });
    sendRequest("Find_Brand").then(({ data }) => {
      setBrandOption(translateBrandToReactSelect(data, false));
    });
    // sendRequest("Find_hashtags").then(({ data }) => {
    //   setTagOption(translateToReactSelect(data, false));
    // });
  }, [products]);

  if (
    productData.length > 0 &&
    tagOption.length > 0 &&
    brandOption.length > 0
  ) {
    for (let i = 0; i < 4; i++) {
      let x = productData[i].url;
      let t = [];
      let b = [];
      let c = [];
      if (x.tags && x.tags.length > 0) {
        for (let j = 0; j < x.tags.length; j++) {
          let z = x.tags[j];
          const v = tagOption.filter(x => {
            if (x.value == z) {
              t.push(x);
            }
          });
        }
      }
      if (x.brands && x.brands.length > 0) {
        for (let j = 0; j < x.brands.length; j++) {
          let z = x.brands[j];
          const v = brandOption.filter(x => {
            if (x.value == z) {
              b.push(x);
            }
          });
        }
      }

      if (t.length > 0 || b.length > 0) {
        setProductData(prev => {
          let temp = [...prev];
          temp[i].url.tags = t;
          temp[i].url.brands = b;

          return temp;
        });
      }
    }
  }

  // console.log("validate", validate);
  // console.log("products", products);
  // console.log("productData", productData);
  // console.log("singleProduct", singleProduct);

  // console.log("query", query);
  return (
    <>
      <div className="modal" id="editSpecialProductModal" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-fullscreen-lg-down">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title"> </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {productData.length > 0 && (
                <form name="editBannerProduct">
                  <div className="my-3">
                    <h4>بنر اول:</h4>
                    <EditBanner
                      singleStatus={displayStatus.Single0}
                      pluralStatus={displayStatus.Plural0}
                      counter="0"
                      changeStatus={changeStatus}
                      productData={productData[0].url}
                      singleProduct={singleProduct[0].ids}
                      changeHandler={changeHandler}
                      changeHandlerSingleProduct={changeHandlerSingleProduct}
                      validate={validate.cover0}
                      tagOption={tagOption}
                      brandOption={brandOption}
                      productOption={productOption}
                      // setProductData={setProductData}
                      // setDisplayStatus={setDisplayStatus}
                    />
                  </div>
                  <div className="my-3">
                    <div className="d-flex align-items-baseline">
                      <h4 className="baner-title">بنر دوم</h4>
                      <div className="baner-line"></div>
                    </div>

                    <EditBanner
                      singleStatus={displayStatus.Single1}
                      pluralStatus={displayStatus.Plural1}
                      counter="1"
                      changeStatus={changeStatus}
                      productData={productData[1].url}
                      singleProduct={singleProduct[1].ids}
                      changeHandler={changeHandler}
                      changeHandlerSingleProduct={changeHandlerSingleProduct}
                      validate={validate.cover1}
                      tagOption={tagOption}
                      brandOption={brandOption}
                      productOption={productOption}
                      // setProductData={setProductData}
                      // setDisplayStatus={setDisplayStatus}
                    />
                  </div>
                  <div className="my-3">
                    <div className="d-flex align-items-baseline">
                      <h4 className="baner-title">بنر سوم</h4>
                      <div className="baner-line"></div>
                    </div>

                    <EditBanner
                      singleStatus={displayStatus.Single2}
                      pluralStatus={displayStatus.Plural2}
                      counter="2"
                      changeStatus={changeStatus}
                      productData={productData[2].url}
                      singleProduct={singleProduct[2].ids}
                      changeHandler={changeHandler}
                      changeHandlerSingleProduct={changeHandlerSingleProduct}
                      validate={validate.cover2}
                      tagOption={tagOption}
                      brandOption={brandOption}
                      productOption={productOption}
                      // setProductData={setProductData}
                      // setDisplayStatus={setDisplayStatus}
                    />
                  </div>
                  <div className="my-3">
                    <div className="d-flex align-items-baseline">
                      <h4 className="baner-title">بنر چهارم</h4>
                      <div className="baner-line"></div>
                    </div>

                    <EditBanner
                      singleStatus={displayStatus.Single3}
                      pluralStatus={displayStatus.Plural3}
                      counter="3"
                      changeStatus={changeStatus}
                      productData={productData[3].url}
                      singleProduct={singleProduct[3].ids}
                      changeHandler={changeHandler}
                      changeHandlerSingleProduct={changeHandlerSingleProduct}
                      validate={validate.cover3}
                      tagOption={tagOption}
                      brandOption={brandOption}
                      productOption={productOption}
                      // setProductData={setProductData}
                      // setDisplayStatus={setDisplayStatus}
                    />
                  </div>

                  <div className="d-flex">
                    <button
                      type="button"
                      className="btn btn-success px-4 fs-5 mt-3 mx-auto"
                      onClick={() => {
                        if (validation()) {
                          saveData();
                        }
                      }}
                    >
                      ثبت
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const EditBanner = ({
  productData,
  singleProduct,
  singleStatus,
  pluralStatus,
  counter,
  changeStatus,
  changeHandler,
  changeHandlerSingleProduct,
  validate,
  tagOption,
  brandOption,
  productOption
}) => {
  // setSectionData((prev) => {
  //   return { ...prev, title: queryObj.title };
  // });
  // sendRequest("productfilter", { hashtags: queryObj.tags.map((value) => value.value).toString(), brandId: queryObj.brands.toString(), fromRate: queryObj.rankRange[0], toRate: queryObj.rankRange[1], fromPrice: queryObj.priceRange[0], toPrice: queryObj.priceRange[1], discount: queryObj.sortTypes.discounted, ascendingPrice: queryObj.sortTypes.cheapest, descendingPrice: queryObj.sortTypes.mostExpensive, ascendingTime: queryObj.sortTypes.newest, inventoryCount: queryObj.sortTypes.inventory }).then(({ data }) => {

  // });

  return (
    <>
      <div className="d-flex flex-wrap ">
        {/* <div className="col-12 col-md-6 px-2">
          <label>نوع لینک:</label>

          <Select
            placeholder="انتخاب نوع لینک..."
            options={[
              { value: "single", label: "تک محصول" },
              { value: "plural", label: "لیست محصولات" },
            ]}
            // value={productData.title.value}
            onChange={(e) => {
              if (e.value == "single") {
                changeStatus(`Single${counter}`, true);
                changeStatus(`Plural${counter}`, false);
              } else if (e.value == "plural") {
                changeStatus(`Plural${counter}`, true);
                changeStatus(`Single${counter}`, false);
              }

              // changeHandler(counter, "title", e.value);
            }}
          />
        </div> */}
        <div className="col-12 col-md-6 px-2">
          <label>انتخاب کاور سکشن:</label>
          <input
            type="file"
            className="form-control"
            onChange={values => {
              changeHandler(counter, "source", values);
            }}
          />
          <p
            style={{
              color: "red",
              fontSize: "12px",
              display: validate == false ? "block" : "none"
            }}
          >
            برای این سکشن کاور وارد نکردید.
          </p>
        </div>
      </div>

      {/* input single product */}
      <div
        className=" flex-wrap my-3"
        style={{
          display: singleStatus == true ? "flex" : "none"
        }}
      >
        <div className="col-12 col-md-6 px-2">
          <label>انتخاب محصول:</label>
          <Select
            options={productOption}
            placeholder="انتخاب محصول ...."
            value={singleProduct.ids}
            onChange={values => {
              changeHandlerSingleProduct(counter, "ids", values);
            }}
            // value={productData.url}
            // onChange={(values) => {
            //   changeHandler(counter, "url", values);
            // }}
          />
        </div>
      </div>

      {/* input product list */}
      <div
        className=" flex-wrap my-3 d-flex"
        // style={{
        //   display: pluralStatus == true ? "flex" : "none",
        // }}
      >
        <div className="col-12 col-md-6 px-2">
          <label>تگ:</label>
          <Select
            isMulti
            options={tagOption}
            value={productData.tags}
            onChange={values => {
              changeHandler(counter, "tags", values);
            }}
          />
        </div>

        <div className="col-12 col-md-6 px-2">
          <label>برند:</label>
          <Select
            isMulti
            options={brandOption}
            value={productData.brands}
            onChange={values => {
              changeHandler(counter, "brands", values);
            }}
          />
        </div>
        <div className="w-100 d-flex flex-column  item-input mt-3">
          <label
            // htmlFor={`edit-modal-brand-${id}`}
            className="form-lable pt-1"
          >
            قیمت :
          </label>
          <div className="w-100 text-center">
            <Slider
              range
              min={0}
              max={100000000}
              value={productData.priceRange}
              step={1000000}
              reverse
              onChange={values => {
                changeHandler(counter, "priceRange", values);
              }}
              // onChange={(value) => {
              //   setProductData((prev) => {
              //     return { ...prev, priceRange: [...value] };
              //   });
              // }}
            />

            <div>
              <p>
                از
                {productData.priceRange && productData.priceRange[0] != ""
                  ? addCommas(productData.priceRange[0])
                  : 0}
                تومان تا
                {productData.priceRange && productData.priceRange[1] != ""
                  ? addCommas(productData.priceRange[1])
                  : 0}{" "}
                تومان
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSpecialProductModal;
